// Get environment variables if exist
const {
  FRONT_END_GRAPHQL_ENDPOINT,
  FRONT_END_AUTH_ENDPOINT,
  FRONT_END_API_ARVORE_ENDPOINT,
  FRONT_END_PDF_UPLOAD_ENDPOINT,
  FRONT_END_ARTICLE_UPLOAD_ENDPOINT,
  FRONT_END_READER_API_ENDPOINT,
  FRONT_END_PHX_API_V1_ENDPOINT,
  FRONT_END_RAILS_API_V3_ENDPOINT,
  FRONT_END_READER_PATH,
  FRONT_END_COMBO_REDIRECTS,
  FRONT_END_SEC_CULTURA_SP_RESET_PASSWORD_URL,
  COMBO_ENVIRONMENT_URL,
  FRONT_END_CMS_STRAPI_API_ENDPOINT,
  FRONT_END_GOOGLE_CLIENT_ID,
  FRONT_END_MICROSOFT_CLIENT_ID,
  FRONT_END_AUDIO_RECORD_UPLOAD_ENDPOINT,
  FRONT_END_READER_V2_PATH,
  FRONT_END_FRESH_CHAT_TOKEN,
  FRONT_END_HANDTALK_TOKEN,
  FRONT_END_HUBSPOT_ID,
  FRONT_END_SPRINKLR_CHAT_APP_ID,
  CDN_URL,
  CDN2_URL
} = process ? process.env : {}

export const API_ENDPOINT = FRONT_END_GRAPHQL_ENDPOINT
  ? FRONT_END_GRAPHQL_ENDPOINT
  : '/graphql'
export const API_ARVORE_ENDPOINT = FRONT_END_API_ARVORE_ENDPOINT
  ? FRONT_END_API_ARVORE_ENDPOINT
  : 'https://livros.arvore.com.br/api-arvore'
export const PHX_API_ENDPOINT = FRONT_END_PHX_API_V1_ENDPOINT
  ? FRONT_END_PHX_API_V1_ENDPOINT
  : '/api/v1'
export const READER_API_ENDPOINT = FRONT_END_READER_API_ENDPOINT
  ? FRONT_END_READER_API_ENDPOINT
  : '/leitor/api'
export const PDF_UPLOAD_ENDPOINT = FRONT_END_PDF_UPLOAD_ENDPOINT
  ? FRONT_END_PDF_UPLOAD_ENDPOINT
  : 'https://livros.arvore.com.br/api/v1/project/pdf_upload'
export const ARTICLE_UPLOAD_ENDPOINT = FRONT_END_ARTICLE_UPLOAD_ENDPOINT
  ? FRONT_END_ARTICLE_UPLOAD_ENDPOINT
  : 'https://livros.arvore.com.br/api/v1/articles/upload_image'
export const AUDIO_RECORD_UPLOAD_ENDPOINT =
  FRONT_END_AUDIO_RECORD_UPLOAD_ENDPOINT
    ? FRONT_END_AUDIO_RECORD_UPLOAD_ENDPOINT
    : 'https://livros.arvore.com.br/api/v1/motrix/upload_audio'
export const TEACHER_WITH_MULTIPLE_ENTITIES_HAS_CHOSEN_ENTITY =
  'TEACHER_WITH_MULTIPLE_ENTITIES_HAS_CHOSEN_ENTITY'
export const READER_WITH_MULTIPLE_CLASSES_HAS_CHOSEN_CLASS =
  'READER_WITH_MULTIPLE_CLASSES_HAS_CHOSEN_CLASS'
export const ITEMS_PER_PAGE = 50
export const PERMISSIONS = {
  // Old permissions. Should be removed after migration
  CAN_CREATE_READER: 'can_create_reader',
  CAN_CREATE_ADMIN: 'can_create_admin',
  CAN_DELETE_READER: 'can_delete_reader',
  CAN_DELETE_ADMIN: 'can_delete_admin',
  CAN_NAVIGATE_BETWEEN_ENTITIES_REGISTERED_TO_ME: 'multiple_entities',
  CAN_ACCESS_ADMIN: 'can_access_admin'
}

export const RAILS_API_V3_ENDPOINT = FRONT_END_RAILS_API_V3_ENDPOINT
  ? FRONT_END_RAILS_API_V3_ENDPOINT
  : 'https://leitor.arvore.com.br/api/v3'

export const READER_PATH = FRONT_END_READER_PATH
  ? FRONT_END_READER_PATH
  : 'https://leitor.arvore.com.br/e/livros/ler'

export const COMBO_REDIRECTS =
  FRONT_END_COMBO_REDIRECTS !== null ? FRONT_END_COMBO_REDIRECTS : true

export const COMBO_URL = COMBO_ENVIRONMENT_URL
  ? COMBO_ENVIRONMENT_URL
  : 'https://app.arvore.com.br'

export const SEC_CULTURA_SP_RESET_PASSWORD_URL =
  FRONT_END_SEC_CULTURA_SP_RESET_PASSWORD_URL
    ? FRONT_END_SEC_CULTURA_SP_RESET_PASSWORD_URL
    : 'https://bibliotecacircula.prefeitura.sp.gov.br/pesquisa/mudaSenha.jsf'

export const CMS_STRAPI_API_ENDPOINT = FRONT_END_CMS_STRAPI_API_ENDPOINT
  ? FRONT_END_CMS_STRAPI_API_ENDPOINT
  : 'https://cms-arvore.arvore.engineering/api/'

export const GOOGLE_CLIENT_ID = FRONT_END_GOOGLE_CLIENT_ID
  ? FRONT_END_GOOGLE_CLIENT_ID
  : '606825167741-dl9bhslm0t9jld59k97p4lnvj2vhrv0s.apps.googleusercontent.com'

export const MICROSOFT_CLIENT_ID = FRONT_END_MICROSOFT_CLIENT_ID
  ? FRONT_END_MICROSOFT_CLIENT_ID
  : '3f5b98fc-ea87-4032-bbd7-33cc36d59ca9'

export const READER_V2_PATH = FRONT_END_READER_V2_PATH
  ? FRONT_END_READER_V2_PATH
  : `https://e-reader.arvore.com.br`

export const FRESH_CHAT_TOKEN = FRONT_END_FRESH_CHAT_TOKEN
  ? FRONT_END_FRESH_CHAT_TOKEN
  : '<secret>'

export const HANDTALK_TOKEN = FRONT_END_HANDTALK_TOKEN
  ? FRONT_END_HANDTALK_TOKEN
  : ''

export const HUBSPOT_ID = FRONT_END_HUBSPOT_ID
  ? FRONT_END_HUBSPOT_ID
  : '<secret>'

export const SPRINKLR_CHAT_APP_ID = FRONT_END_SPRINKLR_CHAT_APP_ID
  ? FRONT_END_SPRINKLR_CHAT_APP_ID
  : '<secret>'

export const ARVORE_ROOT_PATH = 'https://livros.arvore.com.br'
export const AUTH_ENDPOINT = FRONT_END_AUTH_ENDPOINT
  ? FRONT_END_AUTH_ENDPOINT
  : 'https://auth.arvore.com.br'

export const CDN_ENDPOINT = CDN_URL || 'https://cdn.arvore.com.br'

export const CDN2_ENDPOINT = CDN2_URL || 'https://cdn2.arvore.com.br'

export const { PAGARME_ENCRYPTION_KEY } = process.env

export const ARVORE_API_ENDPOINT =
  process.env.ARVORE_API_ENDPOINT || 'https://livros.arvore.com.br/api-arvore'

export const API_ARVORE_ONBOARDING_URL = 'https://livros.arvore.com.br'

export const ACCOUNT_NEXTJS_URL = process.env.FRONT_END_ACCOUNT_NEXTJS_URL || ''
